import tw from "tailwind-styled-components"

const Heading = tw.div`
    flex
    flex-row
    justify-between
    items-end
    text-xl
    mb-1
    mt-4
    border-b-2
    border-secondary-900
    pb-1
    h-14
`;

export default Heading;